import download from "downloadjs";

export async function downloadBase64Async(data: string, mimeType: string, fileName: string) {
    await download(`data:${mimeType};base64,${data}`, fileName, mimeType);
}